import React, { useEffect, useState } from 'react';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import Footer from './Footer';

export default function StudentDashboard() {
  const [studentName, setStudentName] = useState("");
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const { data } = await axios.get(`${baseURL}students/profile`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setStudentName(data.name);
      } catch (error) {
        console.error("Failed to fetch student profile", error);
      }
    };

    fetchProfile();
  }, [baseURL]);

  return (
    <div className='bg-slate-50 min-h-screen'>
      <Header />
      <div className="mt-16 p-4">
        {/* Optional greeting or profile info */}
        {/* <div className="text-right text-gray-600 text-sm mb-2">Welcome, {studentName}</div> */}

        <div className="w-full flex justify-center">
          <div className="w-full max-w-6xl">
            <Outlet />
          </div>
        </div>
      </div>
      
    </div>
  );
}
